import axios from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
});

// Multipart uploads must omit Content-Type so the browser sets the boundary.
axiosInstance.interceptors.request.use((config) => {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    if (config.headers) {
      if (typeof config.headers.delete === 'function') {
        config.headers.delete('Content-Type');
      } else {
        delete config.headers['Content-Type'];
        delete config.headers['content-type'];
      }
    }
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error?.response?.data;
    let message = 'Something went wrong';
    if (typeof data === 'string' && data.trim()) {
      message = data;
    } else if (data && typeof data.message === 'string' && data.message.trim()) {
      message = data.message;
    } else if (data && typeof data.error === 'string' && data.error.trim()) {
      message = data.error;
    } else if (error?.message) {
      message = error.message;
    }
    return Promise.reject(new Error(message));
  }
);

export default axiosInstance;
